// components/layouting/common/FileUploadModal.jsx
import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import api from "../../../services/api";

export default function FileUploadModal({ show, onClose, onUploaded }) {
  const [file, setFile] = useState(null);
  const [jobName, setJobName] = useState("");
  const [autoMarks, setAutoMarks] = useState(true);
  const [markCountH, setMarkCountH] = useState(4);
  const [markCountV, setMarkCountV] = useState(3);
  const [width, setWidth] = useState(825);
  const [height, setHeight] = useState(510);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [isUploading, setIsUploading] = useState(false);

  const handleFileChange = (e) => {
    const f = e.target.files && e.target.files[0];
    setFile(f);
    if (f?.name) {
      setJobName(f.name.replace(/\.[^/.]+$/, ""));
    }
  };

  const reset = () => {
    setFile(null);
    setJobName("");
    setMarkCountH(4);
    setMarkCountV(3);
    setWidth(825);
    setHeight(510);
    setUploadProgress(0);
    setIsUploading(false);
  };

  const handleSubmit = async () => {
    if (!file) return;
    setIsUploading(true);

    const form = new FormData();
    form.append("file", file);

    // если авто-метки выключены → только name
    let qs = `?name=${encodeURIComponent(jobName || file.name)}`;

    if (autoMarks) {
      qs += `&width=${width}&height=${height}&markCountV=${markCountV}&markCountH=${markCountH}`;
    }

    try {
      await api.post(`/layouting/sheets/upload${qs}`, form, {
        headers: { "Content-Type": "multipart/form-data" },
        onUploadProgress: (e) => {
          if (e.total) {
            setUploadProgress(Math.round((e.loaded * 100) / e.total));
          }
        },
      });

      reset();
      onUploaded && onUploaded();
    } catch (err) {
      console.error("Upload failed", err);
    } finally {
      setIsUploading(false);
    }
  };

  return (
    <Modal show={show} onHide={() => { reset(); onClose(); }}>
      <Modal.Header closeButton>
        <Modal.Title>Загрузить скомпонованный лист</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="mb-3">
          <label className="form-label">Название</label>
          <input type="text" className="form-control" value={jobName} onChange={(e) => setJobName(e.target.value)} />
        </div>

        <div className="mb-3">
          <label className="form-label">Файл CDR</label>
          <input type="file" accept=".cdr" className="form-control" onChange={handleFileChange} />
        </div>

        <div className="form-check form-switch mb-3">
          <input
            className="form-check-input"
            type="checkbox"
            id="autoMarksSwitch"
            checked={autoMarks}
            onChange={(e) => setAutoMarks(e.target.checked)}
          />
          <label className="form-check-label" htmlFor="autoMarksSwitch">
            Автоматически проставлять метки
          </label>
        </div>
        
        {autoMarks && (
          <div>
            <div className="row g-2 mb-3">
              <div className="col">
                <label className="form-label">Кол-во меток горизонтально</label>
                <select className="form-select" value={markCountH} onChange={(e) => setMarkCountH(parseInt(e.target.value))}>
                  {[...Array(9)].map((_, i) => <option key={i+2} value={i+2}>{i+2}</option>)}
                </select>
              </div>
              <div className="col">
                <label className="form-label">Кол-во меток вертикально</label>
                <select className="form-select" value={markCountV} onChange={(e) => setMarkCountV(parseInt(e.target.value))}>
                  {[...Array(9)].map((_, i) => <option key={i+2} value={i+2}>{i+2}</option>)}
                </select>
              </div>
            </div>

            <div className="row g-2">
              <div className="col">
                <label className="form-label">Ширина листа (мм)</label>
                <input type="number" className="form-control" value={width} onChange={(e) => setWidth(parseInt(e.target.value || 0))} />
              </div>
              <div className="col">
                <label className="form-label">Высота листа (мм)</label>
                <input type="number" className="form-control" value={height} onChange={(e) => setHeight(parseInt(e.target.value || 0))} />
              </div>
            </div>
          </div>
        )}
        
        {uploadProgress > 0 && (
          <div className="mt-3">
            <div className="progress">
              <div className="progress-bar" style={{ width: `${uploadProgress}%` }}>{uploadProgress}%</div>
            </div>
          </div>
        )}
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={() => { reset(); onClose(); }} disabled={isUploading}>
          Отмена
        </Button>
        <Button variant="primary" onClick={handleSubmit} disabled={!file || isUploading}>
          {isUploading ? "Загрузка..." : "Отправить"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
